import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Form, Input, message, Tooltip } from 'antd';
// import { PlusOutlined, FormOutlined } from '@ant-design/icons';
import { Add, ModifyProperties, Delete, Drag1 } from 'patternx-svg';
import styles from './index.module.less';
import type { DataNode } from 'antd/lib/tree';
// import { IconFont } from '@/components';
import { $$contextmenu } from '@/methods';

interface Props {
  editing: boolean;
  setEditing: (e: boolean) => void;
  node: DataNode & ELEMENT.LabelItem;
  onAdd: (node: ELEMENT.LabelItem) => void;
  onDelete: (node: ELEMENT.LabelItem) => void;
  onSave: (node: ELEMENT.LabelItem, name: string) => void;
  onCreate: (node: ELEMENT.LabelItem, name: string) => void;
  keyword: string;
  lastSelectItem: ELEMENT.LabelItem;
  getTreeItem: (item: ELEMENT.LabelItem) => void;
  setClickPanelItem: (val: boolean) => void;
  setClickTreeItem: (val: boolean) => void;
  isClickTreeItem: boolean;
}
const ItemRender: React.FC<Props> = (props: Props) => {
  const [editor, setEditor] = useState<boolean>(false);
  const [isOK, setIsOK] = useState<boolean>(false);
  const myRef = useRef<HTMLDivElement>({} as HTMLDivElement);
  const inputRef: any = useRef<HTMLInputElement>({} as HTMLInputElement);

  const {
    node,
    onAdd,
    onSave,
    onDelete,
    editing,
    setEditing,
    onCreate,
    keyword,
    lastSelectItem,
    getTreeItem,
    setClickPanelItem,
    isClickTreeItem,
    setClickTreeItem,
  } = props;
  const [form] = Form.useForm();
  const handerAdd = (e: React.MouseEvent<HTMLSpanElement>, n: ELEMENT.LabelItem) => {
    e.stopPropagation();
    e.preventDefault();
    if (n.level === 6) {
      message.warning('最多只能添加7级标签');
      return;
    }
    if (editing) {
      message.warning('同时只能编辑一个标签');
      return;
    }
    setEditing(true);
    onAdd(n);
  };
  const handleEdit = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (editing) {
      message.warning('同时只能编辑一个标签');
      return;
    }
    setTimeout(() => {
      inputRef.current!.focus({
        cursor: 'all',
      });
    }, 0);
    setEditor(true);
    setEditing(true);
  };
  const handleSave = async (n: ELEMENT.LabelItem) => {
    setEditing(false);
    setEditor(false);
    const res = await form.validateFields();

    if (n.name === res.tagName || !res.tagName) {
      setEditor(false);
    } else {
      onSave(n, res.tagName);
    }
  };
  const handerDelete = (n: ELEMENT.LabelItem) => {
    if (n?.children?.length > 0) {
      message.warn('不可删除含有子级的分类');
    } else {
      setEditing(false);
      onDelete(n);
    }
  };

  const handleCreate = async (n: ELEMENT.LabelItem) => {
    if (!isOK) return;
    setEditing(false);
    setEditor(false);
    const res = await form.validateFields();
    onCreate(n, res.tagName);
  };
  const handleEditKeyUp = (e: React.KeyboardEvent, n: ELEMENT.LabelItem) => {
    e.stopPropagation();
    e.preventDefault();
    const target: any = e.target;
    if (e.keyCode === 13) {
      if (!target.value) {
        setEditor(false);
        setEditing(false);
        form.setFieldsValue({ tagName: node.title });
        return;
      } else {
        handleSave(n);
      }
    }
  };

  const handleAddKeyUp = (e: React.KeyboardEvent, n: ELEMENT.LabelItem) => {
    e.stopPropagation();
    e.preventDefault();
    if (e.keyCode === 13) {
      handleCreate(n);
    }
  };
  const render = (title: string) => {
    if (keyword) {
      const reg = new RegExp(keyword, 'g');
      return (
        <div
          className="label-box"
          style={{ width: `${260 - 20 * node.level}px` }}
          dangerouslySetInnerHTML={{
            __html: title.replace(reg, `<span id='highlight'>${keyword}</span>`),
          }}
        />
      );
    } else {
      return (
        <div className="label-box" style={{ width: `${260 - 20 * node.level}px` }}>
          {title}
        </div>
      );
    }
  };
  const handleClick = () => {
    if (node.isAdd || editor) {
      return;
    }
    setClickPanelItem(false);
    setClickTreeItem(true);
    getTreeItem(node);
  };
  const active = useMemo(() => lastSelectItem?.id === node.id, [lastSelectItem, node]);
  useEffect(() => {
    if (active) {
      setTimeout(() => {
        myRef?.current?.scrollIntoView({ block: 'center' });
      }, 0);
    }
  }, [active]);

  const handleContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    if (node.id === 'all') {
      e.preventDefault();
      e.stopPropagation();
      $$contextmenu({
        reference: e.nativeEvent,
        render: () => (
          <div className="item-render-context-menu">
            <div onClick={(ev) => handerAdd(ev, node)}>添加标签</div>
          </div>
        ),
      });
    } else {
      if (!node.isAdd && !editor) {
        e.preventDefault();
        e.stopPropagation();
        $$contextmenu({
          reference: e.nativeEvent,
          render: () => (
            <div className="item-render-context-menu">
              <div onClick={(ev) => handerAdd(ev, node)}>添加标签</div>
              <div onClick={handleEdit}>编辑标签</div>
              <div className="delete" onClick={() => handerDelete(node)}>
                删除标签
              </div>
            </div>
          ),
        });
      }
    }
  };
  const handleAddBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      handerDelete(node);
      message.info('取消新增子标签');
    } else {
      handleCreate(node);
    }
  };
  const handleEditBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setEditor(false);
      setEditing(false);
      form.setFieldsValue({ tagName: node.title });
      return;
    } else {
      handleSave(node);
    }
  };
  return (
    <div
      className={styles.item}
      onClick={handleClick}
      ref={myRef}
      onContextMenu={handleContextMenu}
    >
      {!node.isAdd && (
        <>
          {!editor && (
            <div
              className={
                active
                  ? `${styles.title_active} ${
                      !isClickTreeItem ? styles.title_active_animation : ''
                    }`
                  : styles.title
              }
            >
              {render(node.title)}
            </div>
          )}
          {editor && (
            <Form form={form} name="control-hooks" autoComplete="off" requiredMark={false}>
              <Form.Item
                name="tagName"
                initialValue={node.title}
                rules={[{ message: '请输入标签名称,限20字', max: 20 }]}
                validateTrigger={['onChange', 'onBlur']}
              >
                <Input
                  size="small"
                  onKeyUp={(e) => handleEditKeyUp(e, node)}
                  maxLength={20}
                  ref={inputRef}
                  onBlur={handleEditBlur}
                />
              </Form.Item>
            </Form>
          )}
          <div className={styles.itemBox}>
            {node.level !== 6 && !editor && (
              <span className={styles.iconWrap} onClick={(e) => handerAdd(e, node)}>
                <Add size={20} className={styles.icon} />
              </span>
            )}
            {!editor && node.id !== 'all' && (
              <span className={styles.iconWrap} onClick={handleEdit}>
                <ModifyProperties size={20} className={styles.icon} />
              </span>
            )}
            {!node.flag && node.id !== 'all' && !editor && (
              <span className={styles.iconWrap} onClick={() => handerDelete(node)}>
                <Delete size={20} className={styles.icon} />
              </span>
            )}
            {/* {node.flag && node.id !== 'all' && !editor && (
              <Tooltip title="当前标签下已有文件，不支持删除" placement="right">
                <IconFont type="icon-a-shanchu" className={styles.icon_not_allowed} />
              </Tooltip>
            )} */}
            {node.id !== 'all' && !editor && <Drag1 size={20} className={styles.icon_tuozhuai} />}
          </div>
        </>
      )}
      {!!node.isAdd && (
        <>
          <Form form={form} name="control-hooks" requiredMark={false}>
            <Form.Item
              name="tagName"
              initialValue={node.title}
              rules={[{ message: '请输入标签名称,限20字', max: 20 }]}
              validateTrigger={['onChange', 'onBlur']}
            >
              <Input
                size="small"
                onChange={(e) => {
                  setIsOK(!!e.target.value.trim());
                }}
                placeholder="限20字"
                onKeyUp={(e) => handleAddKeyUp(e, node)}
                autoFocus={true}
                maxLength={20}
                onBlur={handleAddBlur}
              />
            </Form.Item>
          </Form>
        </>
      )}
    </div>
  );
};

export default ItemRender;
